export default __webpack_public_path__ + "static/media/entity-coref-span1.2004fd8b.gif";